import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import DetalhesExameContainer from './detalhesExame/detalhes.container';
import EtapasCommonContainer from './etapas/etapas.common.container';
import EditorContainer from './editor/editor.container';
import { useIntl } from 'react-intl';

const LaudoPage = ({ laudoPageProps }) => {
  const intl =  useIntl();
  return (
    <div>
      <Container fluid className='mv-workspace-container'>
        <Row>
          <Col>
            {laudoPageProps.detalhes && (
              <Row>
                <DetalhesExameContainer
                  detalhes={laudoPageProps.detalhes}
                  etapa={laudoPageProps.etapa}
                  altura={laudoPageProps.altura}
                />
              </Row>
            )}
            {laudoPageProps.detalhes && (
              <Row>
                <EtapasCommonContainer
                  intl={intl}
                  history={laudoPageProps.history}
                  altura={laudoPageProps.altura}
                  detalhes={laudoPageProps.detalhes}
                />
              </Row>
            )}
          </Col>
        </Row>
      </Container>
      <EditorContainer
        history={laudoPageProps.history}
        altura={laudoPageProps.altura}
      />
    </div>
  );
};

export default LaudoPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/laudo.page.js